import React, { useCallback, useEffect, useState } from 'react';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { initFincode } from "@fincode/js"
import ApiFetch from '../ApiFetch';
import { useLocation, useNavigate } from 'react-router';
import LoadingButton from '@mui/lab/LoadingButton';
import { Container, FloatingLabel, Form, Image } from 'react-bootstrap';
import Cropper from 'react-easy-crop';

// aspect,onChange,srcを指定する
const CropButton = (props) => {
  const navigate = useNavigate()
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  let aspect = props.aspect || 2/1
  const [tempImage,setTempImage] = useState("")
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    let image = document.getElementById("load-image-button")
    let canvas = document.createElement("canvas")
    let ctx = canvas.getContext("2d")
    canvas.width = image.width
    canvas.height = image.height

    ctx.drawImage(image,0,0)

    const data = ctx.getImageData(croppedAreaPixels.x,croppedAreaPixels.y,croppedAreaPixels.width,croppedAreaPixels.height)

    canvas.width = croppedAreaPixels.width
    canvas.height = croppedAreaPixels.height

    ctx.putImageData(data,0,0)

    let thumb = canvas.toDataURL("image/png")

    setTempImage(thumb)
  }, [])

  useEffect(() => {

  }, [])

  return (
    <>
      <Image id="load-image-button" className="d-none" src={props.src || ""} />
      <Container id="crop-area-button" />
      {props.show ? (
          <Container>
      <Cropper
          classes={{containerClassName: "cropper-container"}}
          image={props.src}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          onCropChange={setCrop}
          onCropComplete={onCropComplete}
          onZoomChange={setZoom}
      />
          <Container style={{position:"absolute",width:"300px",height:"110px",zIndex:3,left:window.innerWidth / 2 - 150,bottom:"60px",borderRadius:"10px",backgroundColor:"#EEEEEE"}} className="p-3">
              <FloatingLabel controlId="crop-zoom" label="" className="mb-3"
                  style={{position:"absolute",zIndex:3,top:0,width:"90%",fontSize:"24px"}}
              >
                  <Form.Range type="range" defaultValue={zoom} min={1} max={5} step={0.1} onChange={(e) => {
                      setZoom(e.currentTarget.value)
                  }} />
              </FloatingLabel>
              <Button style={{position:"absolute",zIndex:3,left:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                  props.onChange(tempImage)
                  props.setShowCropper(false)
              }}>OK</Button>
              <Button variant='secondary' style={{position:"absolute",zIndex:3,right:"30px",bottom:"10px",fontSize:"24px"}} onClick={() => {
                  props.setShowCropper(false)
                  props.onCancel()
              }}>Cancel</Button>
              </Container>
          </Container>
      ) : ""}
    </>
  )
}

export default CropButton;